import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  eyebrow: {
    id: 'productUpdates.hero.eyebrow',
    defaultMessage: "What's new",
    description: 'Small eyebrow label above the product updates hero title',
  },
  title: {
    id: 'productUpdates.hero.title',
    defaultMessage: 'Eventbrite Product Updates',
    description: 'Main heading of the product updates hero',
  },
  bodyLine1: {
    id: 'productUpdates.hero.bodyLine1V2',
    defaultMessage:
      'Every month, we ship meaningful improvements to Eventbrite based on your feedback.',
    description: 'First line of the hero body copy',
  },
  bodyLine2: {
    id: 'productUpdates.hero.bodyLine2V2',
    defaultMessage:
      'Explore every feature we’ve released, check <roadmap>our product roadmap</roadmap>, or <feedback>share your feedback</feedback>',
    description:
      'Second line of the hero body copy, linking to the product roadmap and the feedback form',
  },
  counterPrimary: {
    id: 'productUpdates.hero.counterPrimary',
    defaultMessage: '{count} new features and improvements',
    description:
      'First part of the hero counter; {count} is the number of improvements shipped since April 2026',
  },
  counterSecondary: {
    id: 'productUpdates.hero.counterSecondary',
    defaultMessage: 'since April 2026',
    description: 'Second part of the hero counter, shown after the count',
  },
});
